// Начальное положение камеры (центр Москвы)
const DEFAULT_VIEW_STATE = {
  longitude: 37.6173,
  latitude: 55.7558,
  zoom: 12,
};

// Варианты светлых бесплатных стилей:

// 1. Carto Positron (минималистичная светлая)
// const MAP_STYLE_URL = "https://basemaps.cartocdn.com/gl/positron-gl-style/style.json";

// 2. Carto Voyager (цветная, детальная)
const MAP_STYLE_URL =
  "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json";

const MAP_STYLES = {
  voyager: "https://basemaps.cartocdn.com/gl/voyager-gl-style/style.json",
  satellite: {
    version: 8,
    sources: {
      esri: {
        type: "raster",
        tiles: [
          "https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
        ],
        tileSize: 256,
      },
    },
    layers: [
      {
        id: "esri-satellite",
        type: "raster",
        source: "esri",
        minzoom: 0,
        maxzoom: 19,
      },
    ],
  },
};

// 3. OpenFreeMap Liberty (светлая)
// const MAP_STYLE_URL = "https://tiles.openfreemap.org/styles/liberty";

// 4. OpenFreeMap Bright (светлая, детальная)
// const MAP_STYLE_URL = "https://tiles.openfreemap.org/styles/bright";

/* Carto Voyager — это не чистый OpenStreetMap, но он основан на данных OSM.
  Технически:
  - Carto использует данные OpenStreetMap как источник
  - Но применяет собственную стилизацию, обработку и рендеринг
  - Добавляет свои картографические улучшения
*/

const POLYGON_OPACITY = 0.2;
const POLYGON_STROKE_WIDTH = 1.5;
const FIT_BOUNDS_PADDING = 20;
const CIRCLE_RADIUS = 5;

const COORDINATE_RULE = {
  pattern: /^-?\d+(\.\d+)?$/,
  message: "Введите корректное числовое значение",
};
const createRangeRule = (min, max, label) => ({
  validator: (_, value) => {
    if (value === undefined || value === null || value === "") {
      return Promise.resolve();
    }
    const numberValue = parseFloat(value);
    if (Number.isNaN(numberValue)) {
      return Promise.reject(new Error("Введите корректное числовое значение"));
    }
    if (numberValue < min || numberValue > max) {
      return Promise.reject(
        new Error(`${label} должна быть в диапазоне от ${min} до ${max}`),
      );
    }
    return Promise.resolve();
  },
});
const LATITUDE_RULE = createRangeRule(-90, 90, "Широта");
const LONGITUDE_RULE = createRangeRule(-180, 180, "Долгота");
const isValidCoordinate = (value, min, max) => {
  const numberValue = parseFloat(value);
  if (Number.isNaN(numberValue)) {
    return false;
  }
  return numberValue >= min && numberValue <= max;
};

export {
  DEFAULT_VIEW_STATE,
  MAP_STYLE_URL,
  MAP_STYLES,
  POLYGON_OPACITY,
  POLYGON_STROKE_WIDTH,
  FIT_BOUNDS_PADDING,
  CIRCLE_RADIUS,
  COORDINATE_RULE,
  LATITUDE_RULE,
  LONGITUDE_RULE,
  isValidCoordinate,
};
